<ion-content fullscreen>
  <app-auth-template [title]="forgotPswProps.sendPswReset">
    <form
      #forgotPassword="ngForm"
      (ngSubmit)="onSubmit(forgotPassword)">
      <ion-item-group class="p-4">

        <!-- EMAIL -->
        <ion-item
          class="radius-4 mt-6"
          lines="full"
          [class.error]="(email.dirty || email.touched) && email.errors">
          <ion-input
            #email="ngModel"
            type="email"
            placeholder="Email"
            name="email"
            required
            email
            ngModel>
          </ion-input>
          <ion-button
            fill="clear"
            slot="end"
            (click)="email.reset()">
            <ion-icon name="close-outline">
            </ion-icon>
          </ion-button>
        </ion-item>
        <div
          *ngIf="(email.dirty || email.touched) && email.errors"
          class="text-red-500 body-3 mt-1 ml-1 pos-abs">
          <span *ngIf="email.errors?.required">
            {{ forgotPswProps.emailRequired }}
          </span>
          <span *ngIf="email.errors?.email">
            {{ forgotPswProps.emailInvalid }}
          </span>
        </div>
      </ion-item-group>
      <ion-button
        class="mx-3 mb-2 ion-button-grey"
        expand="block"
        type="submit"
        [disabled]="forgotPassword.invalid || forgotPassword.pending">
        {{ forgotPswProps.sendPswReset }}
      </ion-button>
      <ion-button
        class="mx-3 mb-2 text-grey-500"
        expand="block"
        fill="clear"
        [replaceUrl]="true"
        [routerLink]="['../login']">
        {{ forgotPswProps.login }}
      </ion-button>
    </form>
  </app-auth-template>
</ion-content>
